import { iteratee, negate, overEvery } from 'lodash-es';

const isNoResult = overEvery([
  iteratee(['data.length', 0]),
  negate(iteratee('loading')),
]);

export default isNoResult;
